import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { SerializableBlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Icon } from "@circle-react-shared/Icon";
import { DESKTOP_WIDTH, MOBILE_WIDTH, TABLET_WIDTH } from "../Canvas/constants";

export interface BlockImagePreviewProps {
  block: SerializableBlockExport;
  isElementType?: boolean;
  name: string;
}

export const BlockImagePreview = ({
  block,
  name,
  isElementType = false,
}: BlockImagePreviewProps) => {
  const { imagePreview } = block;

  if (!imagePreview) {
    return null;
  }

  const isImagePreview = imagePreview.type === "image-url";
  const isIconPreview = imagePreview.type === "icon";

  if (isImagePreview) {
    const srcSet = [
      imagePreview.sm && `${imagePreview.sm} ${MOBILE_WIDTH}w`,
      imagePreview.md && `${imagePreview.md} ${TABLET_WIDTH}w`,
      imagePreview.lg && `${imagePreview.lg} ${DESKTOP_WIDTH}w`,
    ]
      .filter(Boolean)
      .join(", ");

    return (
      <img
        loading="lazy"
        src={imagePreview.lg}
        srcSet={srcSet}
        sizes={`(max-width: ${MOBILE_WIDTH}px) ${MOBILE_WIDTH}px, (max-width: ${TABLET_WIDTH}px) ${TABLET_WIDTH}px, ${DESKTOP_WIDTH}px`}
        alt={t("builder_ui.blocks.preview", { name })}
        className={classNames("max-w-full object-contain", {
          "h-6": isElementType,
        })}
      />
    );
  }

  if (isIconPreview) {
    return <Icon type={imagePreview.name} size={imagePreview.size} />;
  }

  return null;
};
